import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';

export class GuidelineModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('guideline-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'guideline-modal';
      this.dialog.className = 'modal modal--guideline';
      document.body.appendChild(this.dialog);
    }
  }

  open(): void {
    if (!this.dialog) this.render();

    const formatContent = (text: string): string => {
      return text
        .split('\n')
        .map(line => {
          const trimmed = line.trim();
          if (trimmed.startsWith('• ')) {
            return `<li>${trimmed.substring(2)}</li>`;
          }
          if (trimmed === '') {
            return '';
          }
          return `<p>${trimmed}</p>`;
        })
        .join('');
    };

    const howToUseContent = this.i18n.t(I18N_KEYS.GUIDELINE_HOW_TO_USE_CONTENT);
    const howToUseLines = howToUseContent.split('\n');
    const introLine = howToUseLines[0];
    const bulletLines = howToUseLines.filter(l => l.trim().startsWith('• '));
    const howToUseHtml = `<p>${introLine}</p><ul>${bulletLines.map(l => `<li>${l.trim().substring(2)}</li>`).join('')}</ul>`;

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <div class="modal__header">
          <h2>${this.i18n.t(I18N_KEYS.GUIDELINE_TITLE)}</h2>
          <button class="modal__close-btn" type="button" aria-label="Close">&times;</button>
        </div>
        <div class="modal__body guideline__body">
          <section class="guideline__section">
            <h3 class="guideline__section-title">${this.i18n.t(I18N_KEYS.GUIDELINE_ABOUT_TITLE)}</h3>
            <p class="guideline__text">${this.i18n.t(I18N_KEYS.GUIDELINE_ABOUT_CONTENT)}</p>
          </section>
          <section class="guideline__section">
            <h3 class="guideline__section-title">${this.i18n.t(I18N_KEYS.GUIDELINE_HOW_TO_WIN_TITLE)}</h3>
            <p class="guideline__text">${this.i18n.t(I18N_KEYS.GUIDELINE_HOW_TO_WIN_CONTENT)}</p>
          </section>
          <section class="guideline__section">
            <h3 class="guideline__section-title">${this.i18n.t(I18N_KEYS.GUIDELINE_HOW_TO_USE_TITLE)}</h3>
            <div class="guideline__text">${howToUseHtml}</div>
          </section>
        </div>
        <div class="modal__footer">
          <button class="guideline__close-btn btn btn--primary" type="button">${this.i18n.t(I18N_KEYS.GUIDELINE_CLOSE)}</button>
        </div>
      </div>
    `;

    this.dialog!.querySelector('.modal__close-btn')?.addEventListener('click', () => this.close());
    this.dialog!.querySelector('.guideline__close-btn')?.addEventListener('click', () => this.close());

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
